<template>
  <div class="br-subleft overflow-y-auto" :data-min="status">
    <!--<div class="left-side-switch" onclick="sideChangeStatus();">
      <i class="fa" :class="status ? 'fa-angle-double-right':'fa-angle-double-left'"></i>
    </div>-->
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: ["status"]
}
</script>

